import './Main.css';
import Insta from '../Insta/Insta';
import Booking from '../Booking/Booking';
import FAQ from '../FAQ/FAQ';

function Main() {

  return (

    <main>
      <Insta />
      <Booking />
      <FAQ />
    </main>
  )
}

export default Main